module.exports = __webpack_public_path__ + "static/media/pp-2.71cb0fef.jpg";